"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadFeaturesFail = exports.loadFeaturesSuccess = exports.loadFeaturesRequest = void 0;

var _reduxAct = require("redux-act");

var prefix = 'COMMON/FEATURES';
var loadFeaturesRequest = (0, _reduxAct.createAction)("".concat(prefix, "/LOAD_FEATURES_REQUEST"));
exports.loadFeaturesRequest = loadFeaturesRequest;
var loadFeaturesSuccess = (0, _reduxAct.createAction)("".concat(prefix, "/LOAD_FEATURES_SUCCESS"));
exports.loadFeaturesSuccess = loadFeaturesSuccess;
var loadFeaturesFail = (0, _reduxAct.createAction)("".concat(prefix, "/LOAD_FEATURES_FAIL"));
exports.loadFeaturesFail = loadFeaturesFail;